export default [
  {
    name: 'dashboard',
    label: '首页',
    icon: 'ios-home',
    url: '/shell/dashboard'
  },
  {
    name: 'configManage',
    icon: 'ios-settings',
    label: '配置管理',
    children: [
      {
        name: 'ruleOfTrial',
        label: '送审规则',
        url: '/shell/custom/configManage/ruleOfTrial'
      },
      {
        name: 'ruleOfWarning',
        label: '预警规则',
        url: '/shell/custom/configManage/ruleOfWarning'
      },
      {
        name: 'templateReview',
        label: '评阅模板',
        url: '/shell/custom/configManage/templateOfReview'
      },
      {
        name: 'quarterOfReview',
        label: '送审季度设置',
        url: '/shell/custom/configManage/quarterOfReview'
      },
      {
        name: 'typeOfReview',
        label: '上传类型设置',
        url: '/shell/custom/configManage/typeOfReview'
      },
      {
        name: 'fuReviewRuleConfig',
        label: '评阅规则管理',
        url: '/shell/regular/configManage/fuReviewRuleConfig'
      },
      {
        name: 'templateOfReview',
        label: '评阅书模板',
        url: '/shell/custom/configManage/templateOfReview'
      },
      {
        name: 'exportFieldConfig',
        label: '导出字段配置',
        url: '/shell/custom/configManage/exportFieldConfig'
      }
    ]
  },
  {
    name: 'systemManage',
    icon: 'ios-settings',
    label: '系统管理',
    children: [
      {
        name: 'user',
        label: '用户管理',
        url: '/shell/regular/systemManage/user'
      },
      {
        name: 'role',
        label: '角色管理',
        url: '/shell/regular/systemManage/role'
      },
      {
        name: 'menu',
        label: '菜单管理',
        url: '/shell/custom/systemManage/menu'
      },
      {
        name: 'unit',
        label: '单位管理',
        url: '/shell/regular/systemManage/unit'
      },
      {
        name: 'expert',
        label: '专家管理',
        url: '/shell/regular/systemManage/expert'
      },
      {
        name: 'customer',
        label: '客服管理',
        url: '/shell/regular/systemManage/customer'
      },
      {
        name: 'department',
        label: '送审单位管理',
        url: '/shell/regular/systemManage/department'
      },
      {
        name: 'employer',
        label: '接收单位管理',
        url: '/shell/regular/systemManage/employer'
      }
    ]
  },
  {
    name: 'lowerManage',
    icon: 'ios-contacts',
    label: '用户管理',
    children: [
      {
        name: 'academyConfig',
        label: '院系名称维护',
        url: '/shell/regular/lowerManage/academyConfig'
      },
      {
        name: 'department',
        label: '送审单位管理',
        url: '/shell/regular/lowerManage/department2'
      },
      {
        name: 'unitExpert',
        label: '专家管理',
        url: '/shell/regular/lowerManage/unitExpert'
      },
      {
        name: 'employer',
        label: '接收单位管理',
        url: '/shell/regular/lowerManage/employer2'
      }
    ]
  },
  {
    name: 'reviewThesisManage',
    icon: 'ios-paper',
    label: '论文管理',
    children: [
      {
        name: 'matchExpert',
        label: '论文送审管理',
        url: '/shell/regular/reviewThesisManage/matchExpert'
      },
      {
        name: 'earlyWarning',
        label: '评审预警',
        url: '/shell/regular/reviewThesisManage/earlyWarning'
      },
      {
        name: 'uploadThesis',
        label: '论文送审',
        url: '/shell/regular/reviewThesisManage/uploadThesis'
      },
      {
        name: 'processOfThesis',
        label: '论文进度',
        url: '/shell/regular/reviewThesisManage/processOfThesis'
      },
      {
        name: 'academyProcessOfThesis',
        label: '论文进度',
        url: '/shell/regular/reviewThesisManage/academyProcessOfThesis'
      }
    ]
  },
  {
    name: 'allAuthorize',
    label: '全委托送审',
    children: [
      {
        name: 'fuBatchConfig',
        label: '批次配置',
        url: '/shell/regular/allAuthorize/fuBatchConfig',
        query: {
          sendType: '1'
        }
      },
      {
        name: 'fuUploadThesis',
        label: '论文上传',
        url: '/shell/allAuthorize/custom/thesisManage/uploadThesis',
        query: {
          sendType: '1'
        }
      },
      {
        name: 'fuSendPaper',
        label: '论文送审',
        url: '/shell/regular/allAuthorize/fuSendPaper',
        query: {
          sendType: '1'
        }
      },
      {
        name: 'fuProcessOfThesis',
        label: '论文进度',
        url: '/shell/regular/allAuthorize/fuProcessOfThesis',
        query: {
          sendType: '1'
        }
      }
    ]
  },
  {
    name: 'halfAuthorize',
    label: '半委托送审',
    children: [
      {
        name: 'fuBatchConfig',
        label: '批次配置',
        url: '/shell/regular/halfAuthorize/fuBatchConfig',
        query: {
          sendType: '2'
        }
      },
      {
        name: 'fuUploadThesis',
        label: '论文上传',
        url: '/shell/halfAuthorize/custom/thesisManage/uploadThesis'
      },
      {
        name: 'fuProcessOfThesis',
        label: '论文进度',
        url: '/shell/regular/halfAuthorize/fuProcessOfThesis',
        query: {
          sendType: '2'
        }
      }
    ]
  },
  {
    name: 'allSelf',
    label: '自助送审',
    children: [
      {
        name: 'fuBatchConfig',
        label: '批次配置',
        url: '/shell/regular/allSelf/fuBatchConfig',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'fuUploadThesis',
        label: '论文上传',
        url: '/shell/allSelf/custom/thesisManage/uploadThesis',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'feeManage',
        label: '费用管理',
        url: '/shell/regular/customerThesis/feeManage',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'fuSendPaper',
        label: '论文送审',
        url: '/shell/regular/allSelf/fuSendPaper',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'matchExpert',
        label: '论文指派',
        url: '/shell/regular/allSelf/matchExpert',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'fuProcessOfThesis',
        label: '论文进度',
        url: '/shell/regular/allSelf/fuProcessOfThesis',
        query: {
          sendType: '3'
        }
      },
      {
        name: 'fuAddRecordResult',
        label: '评阅结果补录',
        url: '/shell/regular/customerThesis/addRecordResult',
        query: {
          sendType: '3'
        }
      }
    ]
  },
  {
    name: 'expertManage',
    icon: 'ios-person',
    label: '个人信息',
    children: [
      {
        name: 'expertInfo',
        label: '个人信息',
        url: '/shell/custom/expertManage/expertInfo'
      }
    ]
  },
  {
    name: 'unitThManage',
    icon: 'ios-paper',
    label: '论文管理',
    children: [
      {
        name: 'administrativeFee',
        label: '管理费分配',
        url: '/shell/custom/thesisManage/administrativeFee'
      },
      {
        name: 'stayThesis',
        label: '待接收论文',
        url: '/shell/regular/unitThManage/stayReceivedThesis'
      },
      {
        name: 'uploadThesis',
        label: '论文分配',
        url: '/shell/regular/unitThManage/unitUploadThesis'
      },
      {
        name: 'uploadThesis2',
        label: '论文分配',
        url: '/shell/regular/unitThManage/unitUploadThesis2'
      }
    ]
  },
  {
    name: 'thesisManage',
    icon: 'ios-paper',
    label: '论文管理',
    children: [
      {
        name: 'stayThesis',
        label: '待评审论文',
        url: '/shell/regular/thesisManage/thesis'
      },
      {
        name: 'stayThesis',
        label: '待评审论文详情',
        url: '/shell/custom/expertManage/thesisOnlineReview',
        subFlag: true
      },
      {
        name: 'reviewedThesis',
        label: '已评审论文',
        url: '/shell/regular/thesisManage/reviewedThesis'
      },
      {
        name: 'returnThesis',
        label: '退回论文',
        url: '/shell/regular/thesisManage/returnThesis'
      }
    ]
  },
  {
    name: 'customerThesis',
    icon: 'ios-paper',
    label: '论文送审',
    children: [
      {
        name: 'feeManage',
        label: '费用管理',
        url: '/shell/regular/customerThesis/feeManage',
        query: {
          sendType: '1'
        }
      },
      {
        name: 'matchExpert',
        label: '论文送审管理',
        url: '/shell/regular/customerThesis/matchExpert'
      },
      {
        name: 'addRecordResult',
        label: '评阅结果补录',
        url: '/shell/regular/customerThesis/addRecordResult'
      },
      {
        name: 'promptReview',
        label: '催评专家',
        url: '/shell/regular/customerThesis/promptReview',
        query: {
          type: '1'
        }
      },
      {
        name: 'promptUnit',
        label: '催评单位',
        url: '/shell/regular/customerThesis/promptUnit',
        query: {
          type: '2'
        }
      }
    ]
  },
  {
    name: 'userInfoManage',
    icon: 'ios-person',
    label: '个人信息',
    children: [
      {
        name: 'userInfo',
        label: '个人信息',
        url: '/shell/custom/userInfoManage/userInfo'
      }
    ]
  },
  {
    name: 'fundsManage',
    icon: 'ios-paper',
    label: '经费管理',
    children: [
      {
        name: 'applyCashManage',
        label: '提现申请管理',
        url: '/shell/regular/fundsManage/applyCashManage'
      },
      {
        name: 'bankSlipImport',
        label: '回执信息导入',
        url: '/shell/regular/fundsManage/bankSlipImport'
      },
      {
        name: 'historyBill',
        label: '历史打款记录',
        url: '/shell/regular/fundsManage/historyBill'
      },
      {
        name: 'applyCash',
        label: '提现申请',
        url: '/shell/custom/fundsManage/applyCash'
      }
    ]
  },
  {
    name: 'statistic',
    icon: 'ios-stats',
    label: '统计分析',
    children: [
      {
        name: 'analysis',
        label: '统计分析',
        url: '/shell/custom/statisticalAnalysis/index'
      }
    ]
  },
  {
    name: 'subjectAssess',
    icon: 'ios-stats',
    label: '学科评估',
    children: [
      {
        name: 'wheelSubjectAssess',
        label: '学科评估',
        url: '/shell/regular/subjectAssess/wheelSubjectAssess'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/assets/js/menuConfig.js